module.exports = __webpack_public_path__ + "static/media/children4.b2dae952.jfif";